import React, { useState, FormEvent, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";

import loginPic from "../../../assets/logo.jpeg";

const StudentLoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const authContext = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");

    try {
      const response = await fetch("https://has-backend-c48d669d897f.herokuapp.com/user/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Login failed");

      authContext?.login(data.token, data.id, undefined, data.seeGuide);
      console.log(data.canSeeGuide)
      navigate("/student/tablero");
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <div className="flex flex-col sm:flex-row items-center w-full min-h-screen">
    
      {/* Formulario */}
      <div className="flex flex-col w-full sm:w-1/2 items-center px-6 sm:px-0 pt-6 sm:pt-0">
        <div className="flex flex-col items-center">
          <h2 className="text-2xl sm:text-3xl font-playfair text-center">Inicia sesión en tu cuenta</h2>
          <p className="text-base font-sourceSans text-center">Hola! Bienvenido de nuevo</p>
          {error && <p className="text-red-500 mt-2">{error}</p>}
        </div>

        <form className="mt-12 flex flex-col w-full items-center" onSubmit={handleSubmit}>
          <div className="flex flex-col w-[90%] sm:w-1/2 items-start">
            <label className="font-sourceSans mb-1">Correo electrónico</label>
            <input
              className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] w-full shadow-lg py-2 mb-4"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="flex flex-col w-[90%] sm:w-1/2 items-start">
            <label className="font-sourceSans mb-1">Contraseña</label>
            <input
              className="border border-[#8E8E8E] rounded-lg bg-[#FAFAFA] w-full shadow-lg py-2"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="flex flex-col w-[90%] sm:w-1/2 items-end">
            <p className="font-sourceSans text-sm mt-2">¿Olvidaste tu contraseña?</p>
          </div>

          <button
            className="bg-[#1c1c2e] border border-[#8E8E8E] rounded-lg text-white font-sourceSans w-[90%] sm:w-1/2 shadow-lg py-2 mt-12"
            type="submit"
          >
            Iniciar Sesión
          </button>
        </form>
      </div>
            {/* Imagen siempre visible (arriba en mobile, derecha en desktop) */}
      <div className="w-full sm:w-1/2 flex justify-center items-center h-60 sm:h-screen">
        <img className="h-[80%] sm:h-[60%] mx-auto" src={loginPic} alt="login" />
      </div>
    </div>
  );
};

export default StudentLoginPage;
